import qs from 'qs';
import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

type RecentClearsResponse =
  paths['/supplier-market-clears/recent']['get']['responses']['200']['content']['application/json'];
export type RecentClear = RecentClearsResponse['data']['clears'][number];

interface SupplierMarketFilter {
  marketUuid: string;
  supplierDivisionUuid: string;
  makerOrganizationUuid: string;
}

interface RecentClearsProbeParams {
  makerOrganizationUuids?: string[];
  supplierMarket?: SupplierMarketFilter;
}

export async function fetchRecentClearsExistenceProbe(params: RecentClearsProbeParams = {}): Promise<RecentClear[]> {
  const { makerOrganizationUuids, supplierMarket } = params;

  // makerOrganizationUuids uses 'repeat' format (id=1&id=2) to match useTakerHistory serialization.
  // supplierMarkets uses 'indices' format (supplierMarkets[0][key]=val) as required by the API.
  // qs does not support mixed arrayFormat in one call, so we stringify them separately.
  const baseParams = qs.stringify(
    {
      limit: 1,
      ...(makerOrganizationUuids &&
        makerOrganizationUuids.length > 0 && { makerOrganizationUuids: [...new Set(makerOrganizationUuids)] }),
    },
    { arrayFormat: 'repeat' }
  );
  const supplierMarketParams = supplierMarket
    ? qs.stringify({ supplierMarkets: [supplierMarket] }, { arrayFormat: 'indices' })
    : '';
  const searchParams = [baseParams, supplierMarketParams].filter(Boolean).join('&');

  const data = await apiClient
    .get('api/supplier-experience/supplier-market-clears/recent', {
      searchParams,
    })
    .json<RecentClearsResponse>();
  return data?.data?.clears ?? [];
}
